(function() {
  try {
    var wid = $WR.define('cheetahApplication/form/DesignerEditButton', [], function(require, exports, module) {
      var HTML = '';

      var Class = MW.extend(require('designer/form/default/Button'), {
        defaults: {
          xtype: 'editButton',
          xtypeName: '编辑按钮',
          value: "编辑",
          actionName: "编辑",
          action: "formEdit",
          sizeCls: "btn-std",
          iconCls: "fa fa-edit",
          colorCls: "btn-info"
        }
      });
      module.exports = Class;
    });
    $WR.defineType({
      id: wid,
      xtype: 'DesignerEditButton',
      designer: ''
    });
  } catch(e) {
    console.error(e);
  }
})();

(function() {
  var wid = $WR.define('cheetahApplication/form/editButton', [], function(require, exports, module) {
    var HTML = '';
    module.exports = require('form/default/Button');
  });
  $WR.defineType({
    id: wid,
    xtype: 'editButton',
    designer: 'DesignerEditButton'
  });
})();



// WEBPACK FOOTER //
// ./src/common/formWidget/editButton.js